import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I went through YC as an intern, here's what I learned",
  "description": "",
  "published": "2011-08-31T00:00:00.000Z",
  "redirect_from": ["/blog/i-went-through-yc-as-an-intern-heres-what-i-learned/swizec/2345"],
  "categories": "Airbnb, Brian Chesky, California, Silicon Valley, Startup company, Uncategorized, Y Combinator",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Second time I'm writing this post after the official `}<a parentName="em" {...{
          "href": "http://www.moleskine.com/",
          "title": "Moleskine"
        }}>{`Moleskine`}</a>{` app for `}<a parentName="em" {...{
          "href": "http://www.apple.com/ipad/",
          "title": "iPad"
        }}>{`the iPad`}</a>{` ate the first version some 80% through. Don't use it. It doesn't behave as a notebook should ...`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/highres-2eebf2d53a650de548943f24af86894bbb1d92ba1.jpg",
        "alt": null,
        "title": "Coding and then some"
      }}></img></p>
    <p>{`Today was the first day I woke up before noon since coming back to Slovenia a week ago. I was so happy to have gotten over the jet lag that I took it as a sign the impressions have settled in and fermented properly and it's time to write a post.`}</p>
    <p>{`I spent the summer working as an intern for DoubleRecall through their `}<a parentName="p" {...{
        "href": "http://www.ycombinator.com",
        "title": "Y Combinator"
      }}>{`YCombinator`}</a>{` experience. Then I came back home to get some exams done before the next year of school; I would love to have stayed longer!`}</p>
    <p><em parentName="p">{`tl;dr --> super awesome times, you seriously want to do something like this`}</em></p>
    <p>{`Despite everything people said last night on the #startups `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet_Relay_Chat",
        "title": "Internet Relay Chat"
      }}>{`IRC channel`}</a>{`, even a startup such as DoubleRecall - a startup that will obviously make a gazillion dollars - isn't a good reason to drop out of school when you're not a founder.`}</p>
    <p>{`I can only hope when the founders are dumping truckloads of hundred dollar bills into their swimming pools rather than water - they'll keep me and my antics in good memory :)`}</p>
    <p>{`Which brings me right to the first lesson I picked up:`}</p>
    {
      /*more*/
    }
    <h2 {...{
      "id": "1-be-controversial---it-works-bitchz"
    }}>{`1. Be controversial - it works bitch'z`}</h2>
    <p>{`Now I'm not certain how much of this I'm allowed to say in public, but someone will surely rise up and slap me over the wrist if I say too much. Then I will edit this section. Perhaps even delete it.`}</p>
    <p>{`You might have heard of Fukime, it was a small and simple service that "launched" sometime mid-August. I was in charge of making sure as many of you heard of it as possible.`}</p>
    <p>{`At the same time `}<a parentName="p" {...{
        "href": "https://www.parse.com/"
      }}>{`Parse`}</a>{` was launching and because the two things are remotely similar I decided to piggyback on their publicity ... granted, very poor judgement on my part and I should have known better.`}</p>
    <p>{`The whole thing went up the nose of some people high up in YC because something like this has not happened in the whole history of the programme.`}</p>
    <p>{`It even went so far I had to go defend my actions to the YC offices; even got personally picked up at the train station!`}</p>
    <p>{`Good or bad, how many interns got on YC's radar this summer do you think? I'm pretty sure my next application will at least get a good read.`}</p>
    <h2 {...{
      "id": "2-location-matters-in-unexpected-ways"
    }}>{`2. Location matters in unexpected ways`}</h2>
    <p>{`As a developer in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.37,-122.04&spn=1.0,1.0&q=37.37,-122.04%20(Silicon%20Valley)&t=h",
        "title": "Silicon Valley"
      }}>{`Silicon Valley`}</a>{` I can't say I felt any productive boost from the location itself outside the climate (summers in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.0,-120.0&spn=10.0,10.0&q=37.0,-120.0%20(California)&t=h",
        "title": "California"
      }}>{`Califronia`}</a>{` are fucking divine), the change of surroundings and such.`}</p>
    <p>{`Especially being couped up in a house with a bunch of guys who are always working - no commuting - no girlfriends - nothing but us and a mission to make something happen.`}</p>
    <p>{`You don't need to move halfway across the world to get that, you could just as easily put a bunch of developers into a house anywhere in the world and the magic would happen.`}</p>
    <p>{`Everyone feeding off each other, ideas flowing. Shit getting done.`}</p>
    <p>{`Seems like it was much different for the business guys though. They were on fire!`}</p>
    <p>{`Having meetings like a boss. With people that just aren't available anywhere else in the world. "Be where your customers are", as wise people have said.`}</p>
    <p>{`It actually works.`}</p>
    <h2 {...{
      "id": "3-work-hard-party-harder"
    }}>{`3. Work hard, party harder`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/11f3ebb3ac804d4182fc72487e333a56_71.jpg",
        "alt": null,
        "title": "You can even work in the shower"
      }}></img></p>
    <p>{`Being in an environment where everyone is working pretty much from waking to sleeping can make even the strongest of men a workoholic.`}</p>
    <p>{`The encouragement is there. The culture is there. All the conditions are perfect. You're there with a single purpose.`}</p>
    <p>{`And so you code.`}</p>
    <p>{`All day.`}</p>
    <p>{`But no matter how much of a robot you are, eventually it will wear on you and you will start pumping out garbage by the truckload. You are much more useful when you are only pumping out code by the cartload - code so beautiful it would put the sixtine chapel to shame.`}</p>
    <p>{`It's important to unwind and just be.`}</p>
    <p>{`You might not be able to party in the Valley itself since ... well there's just nowhere to party, everyone is a always working.`}</p>
    <p>{`San Francisco is right there though. A train ride away. And it is a fucking spectacular place to party even if all the clubs do close up at 3am.`}</p>
    <h2 {...{
      "id": "4-cool-people-dont-live-inside-your-computer"
    }}>{`4. Cool people don't live inside your computer`}</h2>
    <p>{`Similar to the note about partying to unwind and get a fresh set of brains to look at problems, you will likely find that being in the Valley suddenly means that most of the cool people aren't in the computer anymore.`}</p>
    <p>{`They're out there. At the starbuckses and peetses of the world!`}</p>
    <p>{`Going out to meet them is fun.`}</p>
    <p>{`Most of the time they don't bite and the stories they tell are pretty interesting - not to mention how often does it happen that talking shop with a stranger produces another stranger who just starts talking shop with the two of you because they overheard something interesting?`}</p>
    <p>{`Plus it's another opportunity to slightly unwind and let your subconscious work on Real Problems (tm).`}</p>
    <h2 {...{
      "id": "5-side-projects-are-important"
    }}>{`5. Side projects are important`}</h2>
    <p>{`Just as you need some time to unwind, so does the team as a whole.`}</p>
    <p>{`This is of course anecdotal evidence, but I think the whole team dropping everything to do with the core project and working on something lighthearted and fun for a week really helped.`}</p>
    <p>{`Fuck teambuilding exercises and whatever crap corporates throw at employees in the movies. Side projects are where it's at! The whole team has a bit of fun and at the end of the week, everyone is fresh to look at the important problems again.`}</p>
    <p>{`Better still, you might have used the side project to approach That Really Annoying Hard Problem (tm) from a new perspective and it suddenly became very obvious.`}</p>
    <h2 {...{
      "id": "6-runways-are-a-pretty-big-deal"
    }}>{`6. Runways are a pretty big deal`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/5d7f30542de74f2a982db3ac03e3925d_71.jpg",
        "alt": null,
        "title": "Chinese, lots of it"
      }}></img></p>
    <p>{`This lesson is a bit personal due to the experiences with the first and latest real startup I've founded.`}</p>
    <p>{`Turns out the whole team works a lot better when everybody knows where the next meal is coming from. I know it's not kosher to say that startups need money and investments because people need to put food on the table (investments are for "runways" and "moar everything" and "marketing" and "servers" etc), but fuck it.`}</p>
    <p>{`Money matters. People use it to survive.`}</p>
    <h2 {...{
      "id": "7-for-an-employee---startups-are-pure-fucking-fun"
    }}>{`7. For an employee - startups are pure fucking fun`}</h2>
    <p>{`On that note: it is much easier to work at a startup than it is to be a founder.`}</p>
    <p>{`Nothing but pure fun!`}</p>
    <p>{`All the perks of a startup environment, without any of the aches and pains of actually having to make sure stuff works and the startup functions as a well oiled machine.`}</p>
    <p>{`That said, it isn't even half as satisfying. No matter how much you believe in the idea. Outside of a year long (at most) sabbatical I'll take the pain and the blood and the tears any day of the week.`}</p>
    <p>{`What I don't understand is why anyone would work at something other than a startup ... but that's fodder for a different post.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/8024ae956d1e4bebbf2562477c22dc4e_71.jpg",
        "alt": null,
        "title": "Energy drinkz"
      }}></img></p>
    <h2 {...{
      "id": "8-yc-dinners-take-plenty-of-energy"
    }}>{`8. YC dinners take plenty of energy`}</h2>
    <p>{`As a hired gun I only ever got to attend a single YC dinner annd the main impression was one of immensenes.`}</p>
    <p>{`I'd only gotten two hours of sleep that day and then there were just so many people to talk to. Everyone looked awesome, everyone looked like they could share cool stories long into the night.`}</p>
    <p>{`I was too tired for all of it.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.crunchbase.com/person/brian-chesky",
        "title": "Brian Chesky"
      }}>{`Brian Chesky`}</a>{` of `}<a parentName="p" {...{
        "href": "http://www.airbnb.com/",
        "title": "Airbnb"
      }}>{`Airbnb`}</a>{` fame was the speaker at "my" dinner. His story was amazing, striked quite close to home for me, but I think I slept through at least half of the Q&A session ... paying attention for four hours is simply too much.`}</p>
    <p>{`Hopefully this wasn't the last dinner I'll ever attend because there was so much more I could have gotten out of it ...`}</p>
    <h2 {...{
      "id": "9-your-pitch-needs-more-work"
    }}>{`9. Your pitch needs more work`}</h2>
    <p>{`The last few days of my stay were marked by the whole team focusing on making sure any member of the core team had the perfect pitch to tell on demo day.`}</p>
    <p>{`The best guy would end up doing it.`}</p>
    <p>{`I had to leave on demo day and even if I didn't, I wouldn't be allowed to listen in, but from what I hear the guys totally owned it and everything went swimmingly.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.crunchbase.com/person/steve-jobs",
        "title": "Steve Jobs"
      }}>{`Steve Jobs`}</a>{` once said it takes an hour of preparation for every minute of a presentation.`}</p>
    <p>{`Try four days for a two minute pitch.`}</p>
    <h2 {...{
      "id": "10-you-want-to-do-this"
    }}>{`10. You want to do this`}</h2>
    <p>{`As a founder or as an anything, you want to get locked up in a house with a cool team and make something awesome.`}</p>
    <p>{`Conclusion`}</p>
    <p>{`The whole summer was one huge experience I will always look back on fondly. Since I'm of a very forgetful nature I probably won't remember much more than the general feeling and by the time I'm grampa age I will be telling war stories of this summer like a boss.`}</p>
    <p>{`And I won't even have to fabricate anything. The real story is good enough.`}</p>
    <p>{`Shoot me a line pretty much anywhere if there's anything you want to ask. I learned more than fits in a post.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-couldnt-get-into-yc-so-i-joined-a-startup-that-did/swizec/1855"
        }}>{`I couldn't get into YC so I joined a startup that did`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.jazzychad.net/2011/08/31/applying-to-yc-as-a-single-founder.html"
        }}>{`Applying to YC as a Single Founder`}</a>{` (jazzychad.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.giftrocket.com/blog/does-paul-graham-get-what-he-asks-for"
        }}>{`Does Paul Graham Get What He Asks For? `}{`[`}{`infographic`}{`]`}</a>{` (giftrocket.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/08/31/ycs-patent-pledge-asks-tech-companies-to-grant-startups-patent-immunity/"
        }}>{`YC's Patent Pledge Asks Tech Companies To Grant Startups Patent Immunity`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.ycombinator.com/item?id=2879055"
        }}>{`For the love of God, YC companies-to-be stop posting ambiguous job description`}</a>{` (news.ycombinator.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://launchpadtoys.com/blog/2011/08/y-combinator-shattered-my-robot-loving-dreams/"
        }}>{`Y Combinator Shattered My Robot Loving Dreams`}</a>{` (launchpadtoys.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5375981d-e282-454d-b9cc-fea2a49517d2",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      